import script from "./indexList.vue?vue&type=script&lang=ts&setup=true"
export * from "./indexList.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__